import { Loader } from "../../../../../../../../components/Loader/Loader.component";
import { styled } from "../../../../../../../../theme/default/styled";

export const SLoader = styled(Loader)`
  margin: 0 auto;
`;
